"use client"

import { useState } from "react"
import "./DAFaq.css"

const faqData = [
  {
    question: "What is Digital Acceleration?",
    answer:
      "Digital acceleration is the strategic adoption of digital technologies to enhance business processes, customer experiences, and operational efficiency. It goes beyond mere digitization (converting analog to digital). It involves a holistic transformation that integrates digital technology into all business areas, fundamentally changing how the business operates and delivers value to customers. It's a response to the digital era's rapid changes. It is driven by the need to stay competitive in an increasingly digital marketplace.",
  },
  {
    question: "Why is Digital Aceleration Important?",
    answer:
      "In the digital age, customer expectations, market conditions, and technological capabilities are evolving at an unprecedented pace. Digital acceleration is essential because it enables businesses to:• Respond Rapidly to Market Changes: Quickly adapt to market dynamics and customer preferences.• Enhance Customer Experience: Utilize digital channels and tools to offer personalized and efficient customer service.• Drive Innovation: Leverage emerging technologies to develop new products, services, and business models.• Improve Operational Efficiency: Automate processes and use data analytics for better decision-making.• Stay Competitive: Keep pace with or outperform competitors in adopting digital practices.",
  },
  {
    question: "Who uses Digital Acceleration?",
    answer:
      "Digital acceleration is embraced by a diverse range of organizations, including:• Small and Medium-sized Enterprises (SMEs): To expand market reach, optimize resources, and innovate rapidly.• Large Corporations: To maintain market dominance, improve global operations, and drive large-scale innovation.• Startups: To disrupt traditional markets with innovative digital-first approaches.• Non-profits and Government Agencies: To enhance service delivery and engage effectively with stakeholders.",
  },
  {
    question:
      "What are the key components of Digital Acceleration?",
    answer:
      "The key components include:• Advanced Technologies: Such as AI, IoT, cloud computing, and big data analytics.‍Digital Culture: Fostering a culture that embraces change, innovation, and continuous learning.• Customer-Centric Approach: Using digital tools to gain insights into customer behavior and preferences.• Agile Methodologies: Implementing flexible and iterative project management and product development approaches.• Cybersecurity Measures: Ensuring data integrity and security in a digital environment..",
  },
  {
    question: "How does Digital Acceleration impact Customer Experience?",
    answer:
      "Digital acceleration transforms the customer experience by:• Personalization: Offering tailored products, services, and interactions based on customer data.• Convenience: Providing seamless and efficient online services and support.• Engagement: Using digital channels for continuous and interactive customer communication.• Accessibility: Ensuring services are available across various digital platforms and devices.",
  },
  {
    question: "Can small Bussiness Benefit from Digital Acceleration?",
    answer:
      "Yes, small businesses can significantly benefit from digital acceleration. It allows them to:• Compete with Larger Enterprises: By leveraging digital tools to offer unique or superior customer experiences.‍• Access Global Markets: Through digital marketing and e-commerce platforms.• Operate Efficiently: By automating processes and reducing operational costs.• Innovate Quickly: Rapidly test and deploy new ideas and solutions.",
  },
  {
    question:
      "What are challenges of Digital Acceleration?",
    answer:
      "Key challenges include:‍• Resource Allocation: Balancing the investment in new technologies with ongoing operations.• Data Security and Privacy: Protecting sensitive information in a digital landscape.• Integration of Technologies: Seamlessly integrating new digital solutions with existing systems.• Skill Gaps: Ensuring the workforce has the skills required for new digital tools and methodologies.",
  },
 
 
]

const FAQSection = () => {
  const [openItems, setOpenItems] = useState([])

  const toggleItem = (index) => {
    setOpenItems((prev) => (prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]))
  }

  return (
    <div className="faq-container" id="faq">
      <div className="container">
      <div className="faq-wrapper">
        {/* Header */}
        <div className="header-section5120">
          <h1 className="main-title">EVERYTHING YOU NEED TO KNOW ABOUT</h1>
          <h2 className="sub-title">DIGITAL ACCELERATION</h2>
        </div>

        <div className="content-grid">
          {/* Left Sidebar */}
          <div className="sidebar">
            <div className="sidebar-image">
              <img src="/faq.webp?height=10&width=10" alt="FAQ Illustration" />
            </div>

            <div className="sidebar-content">
              <p className="sidebar-text">
                Browse the Frequently Asked Questions and get your answers. Or better yet - get in touch with our team
                and let's talk!
              </p>
              <button className="quote-button">GET A QUOTE</button>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="faq-section">
            <div className="faq-list">
              {faqData.map((faq, index) => (
                <div key={index} className="faq-item">
                  <div className="faq-question" onClick={() => toggleItem(index)}>
                    <p className="question-text">{faq.question}</p>
                    <div className="chevron-icon">
                      {openItems.includes(index) ? (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="18,15 12,9 6,15"></polyline>
                        </svg>
                      ) : (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="6,9 12,15 18,9"></polyline>
                        </svg>
                      )}
                    </div>
                  </div>
                  {openItems.includes(index) && (
                    <div className="faq-answer">
                      <p className="answer-text">{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Scroll Indicator */}
            <div className="scroll-indicator">
              <div className="scroll-dot"></div>
              <div className="scroll-bar"></div>
              <div className="scroll-dot"></div>
            </div>
          </div>
        </div>

        {/* Bottom CTA Section */}
        <div className="cta-section">
          <div className="cta-content">
            <div className="cta-text">
              <h3 className="cta-title">STILL HAVE QUESTIONS?</h3>
              <p className="cta-description">
                Our team of business developers and project managers can help you to clarify any questions you have
                related. Feel free to chat with us anytime.
              </p>
            </div>
            <button className="call-button">BOOK A CALL</button>
          </div>
        </div>
      </div>
      </div>
    </div>
  )
}

export default FAQSection
